import Vue from 'vue'
import VueRouter from 'vue-router'
import Admin from '_views/Admin'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: Admin,
    children: [
      {
        path: '/',
        redirect: '/hlxj',
        meta: {
          // 设置角色鉴权，只要对应的角色才能访问对应页面
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/hlxj',
        name: '首页',
        component: () => import('_views/dashBoard'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/product',
        name: '好粮心产品',
        component: () => import('_views/product'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/productIntro',
        name: '产品详情',
        component: () => import('_views/productIntro'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/news',
        name: '新闻中心',
        component: () => import('_views/news'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/marketing',
        name: '娱乐营销',
        component: () => import('_views/marketing'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/dynamic',
        name: '光良动态',
        component: () => import('_views/dynamic'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/about',
        name: '关于好粮心',
        component: () => import('_views/about'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/cooperation',
        name: '招商合作',
        component: () => import('_views/cooperation'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      },
      {
        path: '/contactus',
        name: '联系我们',
        component: () => import('_views/contactus'),
        meta: {
          roles: ['admin', 'a', 'b', 'superAdmin']
        }
      }
      // {
      //   path: '/SetTing',
      //   name: '设置',
      //   component: () => import('_views/SetTing'),
      //   meta: {
      //     roles: ['a', 'b', 'superAdmin']
      //   }
      // }
    ]
  },
  // {
  //   path: '/login',
  //   component: () => import('_views/Login'),
  //   meta: {
  //     roles: '*'
  //   }
  // },
  {
    path: '/noAuth',
    component: () => import('_views/noPermission'),
    meta: {
      roles: '*'
    }
  },
  {
    path: '/404',
    component: () => import('_views/NotFound'),
    meta: {
      roles: '*'
    }
  },
  {
    path: '*',
    component: () => import('_views/NotFound'),
    meta: {
      roles: '*'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // console.log(to.path.slice(1), 'jjj')
  if (to.meta.roles === '*') {
    next()
  } else {
    next()
  }
  // if (to.path !== '/login') {
  //   if (isLogin()) {
  //     // 登陆成功后判断用户访问的页面是否符合权限

  //   } else {
  //     next('/dashBoard')
  //   }
  // } else {
  //   next()
  // }
})
export default router
